import React from 'react';
import { InvoiceData } from '../types';

interface InvoiceDetailsProps {
  invoice: InvoiceData;
}

function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString();
}

export function InvoiceDetails({ invoice }: InvoiceDetailsProps) {
  const statusBadge = (
    <span className={`px-2 py-0.5 rounded text-xs ${
      invoice.status === 'paid' ? 'bg-green-100 text-green-800' :
      invoice.status === 'partial' ? 'bg-yellow-100 text-yellow-800' :
      'bg-red-100 text-red-800'
    }`}>
      {invoice.status.toUpperCase()}
    </span>
  );

  return (
    <div
      style={{
        fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
      }}
    >
      <div className="font-semibold mb-1">Invoice Details</div>
      <div className="space-y-0.5 text-[13px]">
        <div><span className="font-semibold">Invoice No:</span> {invoice.invoice_number}</div>
        <div><span className="font-semibold">Issue Date:</span> {formatDate(invoice.issue_date)}</div>
        {invoice.due_date && (
          <div><span className="font-semibold">Due Date:</span> {formatDate(invoice.due_date)}</div>
        )}
        <div><span className="font-semibold">Status:</span> {statusBadge}</div>
      </div>
    </div>
  );
}

export default InvoiceDetails;
